import { render, staticRenderFns } from "./addToken.vue?vue&type=template&id=1ae013b8&scoped=true&lang=pug&"
import script from "./addToken.vue?vue&type=script&lang=js&"
export * from "./addToken.vue?vue&type=script&lang=js&"
import style0 from "./addToken.vue?vue&type=style&index=0&id=1ae013b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae013b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae013b8')) {
      api.createRecord('1ae013b8', component.options)
    } else {
      api.reload('1ae013b8', component.options)
    }
    module.hot.accept("./addToken.vue?vue&type=template&id=1ae013b8&scoped=true&lang=pug&", function () {
      api.rerender('1ae013b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/assets/dialog/addToken.vue"
export default component.exports